export const getSiteId = state => state.siteId;
